var angular = require('angular')

angular.module('AemBranchesAppointments')
  .component('appointmentCancel', {
    template: require('./appointment-cancel.component.tpl.html'),
    controller: AppointmentCancelCtrl,
    controllerAs: 'vm',
    bindings: {}
  })

AppointmentCancelCtrl.$inject = ['appLoader', 'appointmentsService', '$routeParams', 'wgService', 'i18n']

function AppointmentCancelCtrl (appLoader, appointmentsService, $routeParams, wgService, i18n) {
  var vm = this

  vm.$onInit = function () {
    vm.error = null
    vm.appointment = null
    vm.cancelled = false
    vm.branchDetailUrl = null

    vm.cancel = cancel

    appointmentsService.get($routeParams.appointmentId)
      .then(function (res) {
        vm.appointment = res.data
        vm.branchDetailUrl = (wgService.getParams().branchDetailUrl &&
          wgService.getParams().branchDetailUrl[i18n.langCode].replace('%{id}', vm.appointment.branch.id)) || null
      })
      .catch(function (err) {
        vm.error = err
      })
      .finally(function () {
        appLoader.hide()
      })
  }

  function cancel () {
    appLoader.show()
    appointmentsService.remove($routeParams.appointmentId)
      .then(function () {
        vm.cancelled = true
      })
      .catch(function (err) {
        vm.error = err
      })
      .finally(function () {
        appLoader.hide()
      })
  }
}
